import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { useRef } from 'react';
import Rheostat from 'rheostat';

import formatPrice from '../../../util/formatPrice';

const propTypes = exact({
  blockName: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  isCurrency: PropTypes.bool,
  labelText: PropTypes.string,
  labelValuePrefix: PropTypes.string,
  maximumValue: PropTypes.number,
  minimumValue: PropTypes.number,
  selectedValues: PropTypes.arrayOf(PropTypes.number),
});

const defaultProps = {
  blockName: null,
  isCurrency: false,
  labelText: null,
  labelValuePrefix: null,
  maximumValue: 0,
  minimumValue: 0,
  selectedValues: [0, 0],
};

function Range(props) {
  const suppressNextClick = useRef(false);

  const handleSliderDragEnd = () => {
    // A fast release can land the mouseup off the handle and onto the bare
    // track. Rheostat then treats the resulting click as "jump the nearest
    // handle here", snapping a handle the user never touched. Swallow the
    // click that immediately follows a drag so it can't override it.
    suppressNextClick.current = true;
  };

  const handleTrackClickCapture = (event) => {
    if (suppressNextClick.current) {
      suppressNextClick.current = false;
      event.stopPropagation();
    }
  };

  const valueFrom = `${props.labelValuePrefix}${
    props.isCurrency ? formatPrice(Number(props.selectedValues[0])) : props.selectedValues[0]
  }`;
  const valueTo = `${props.labelValuePrefix}${
    props.isCurrency ? formatPrice(Number(props.selectedValues[1])) : props.selectedValues[1]
  }`;

  const containerClasses = classNames(props.blockName, 'Range');

  return (
    <div className={containerClasses}>
      <div className="Range_label">
        {props.labelText && <span className="Range_labelText">{props.labelText}</span>}
        <span className="Range_labelValue">
          {valueFrom}-{valueTo}
        </span>
      </div>
      <div className="Range_slider" onClickCapture={handleTrackClickCapture}>
        <Rheostat
          max={props.maximumValue}
          min={props.minimumValue}
          onChange={props.handleChange}
          onSliderDragEnd={handleSliderDragEnd}
          values={props.selectedValues}
        />
      </div>
    </div>
  );
}

Range.propTypes = propTypes;
Range.defaultProps = defaultProps;

export default Range;
